export default __webpack_public_path__ + "static/media/doYouNeedAnAppleTV.55243ce7.md";